angular.module('picmonicng').factory('GraduationSourcingModal', [
  '$modal',
  function ($modal) {
    return {
      show: function () {
        $modal.open({
          templateUrl: '/templates/app/factories/graduation-sourcing-modal/graduation-sourcing-modal.html',
          windowClass: 'graduation-sourcing-modal',
          controller: [
            '$scope',
            '$q',
            'toaster',
            'UserService',
            'User',
            function ($scope, $q, toaster, UserService, User) {
              $scope.loading = true;
              $scope.saving = false;
              $scope.error = '';
              $scope.UserService = UserService;

              $scope.graduation = {
                year: null,
                month: null,
              };

              $scope.years = [];
              var start_year = new Date().getFullYear();
              for (var a = 0; a < 10; a++) {
                $scope.years.push(start_year + a);
              }

              $scope.months = {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December',
              };

              if (typeof atlasEvent !== 'undefined') {
                atlasEvent('click', 'graduation_sourcing_modal_seen');
              }

              $scope.machine = User.getv3(
                { resource: 'graduation_recommendations' },
                function () {
                  if ($scope.machine.year && $scope.machine.month) {
                    $scope.graduation.year = $scope.machine.year;
                    $scope.graduation.month = $scope.machine.month;
                  } else {
                    $scope.graduation.year = new Date().getFullYear() + 1;
                    $scope.graduation.month = new Date().getMonth() === 11 ? 1 : new Date().getMonth() + 1;
                  }

                  $scope.loading = false;
                },
                function () {
                  $scope.loading = false;
                }
              );

              $scope.formIsValid = function () {
                return $scope.graduation.year && $scope.graduation.month;
              };

              $scope.save = function () {
                if (!$scope.formIsValid() || $scope.saving) {
                  return;
                }

                $scope.saving = true;
                $scope.error = '';

                UserService.user.graduation_year = $scope.graduation.year;
                UserService.user.graduation_month = $scope.graduation.month;

                UserService.user.$update(
                  function () {
                    $scope.$close();
                    $scope.saving = false;
                    toaster.success('Your graduation date has been updated.');
                  },
                  function (error) {
                    $scope.error = error.data.message;
                    $scope.saving = false;
                  }
                );
              };
            },
          ],
        });
      },
    };
  },
]);
